import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const GoBackContainer = styled.div`
  @media (min-width: ${Breakpoints.b1280}px) {
    display: none;
  }

  span {
    text-decoration: none;
  }
`;
